import React, { useState, useEffect} from "react";
import { Input, notification,Alert } from "antd";
import { LockOutlined, UserOutlined, QrcodeOutlined } from '@ant-design/icons';
import { Auth } from 'aws-amplify';
import moment from "moment";

const Verify = ({verify}) => {  
  const [daTes, setDates] = useState();
  const [daYs,  setDays]  = useState();

  const [disabled, setDisabled] = useState(false);

  const [verifyInfo, setVerfyInfo] = useState({
	  email:"",
	  code:""
  })

  useEffect(() => {
  	setVerfyInfo({...verifyInfo, email: localStorage.getItem('email')});
    setDates(moment().format("MMMM Do YYYY"));
    setDays(moment().format("dddd"));
  },[])

  const handleChange = (event) => {
      setVerfyInfo({...verifyInfo, [event.target.name]:event.target.value});
  }

  const handleSubmit = (event) => {
	 event.preventDefault();
	 setDisabled(true);
	 verify(verifyInfo)
  }
  
  return (
	<>
	<div className="mainLogin-div">
	<div className="mainHeader-login">
			<div className="loginHead-title">
				<img
				src="https://quezoncity.gov.ph/wp-content/themes/qcproject/images/qclogo_main.png"
				alt="QCLogo"
				/>
				<span>Quezon City</span>
			</div>
			<div className="loginHead-date">
				{`${daTes}, ${daYs}`}
			</div>
		</div>
	  <div className="loginCard-div">
		<form onSubmit={(e) => handleSubmit(e)} className="loginCard-left">
		<div className="loginTitle" style={{marginBottom:"10px", fontSize:"50px"}}>
				QC
			</div>
			<div className="loginTitle" style={{marginBottom:"10px", fontWeight:"normal"}}>
				Department of Building Official (LOI)
			</div>
			
			<Alert message="Verify Your Account" type="warning" style={{width:"80%",textAlign:"center", margin:15}} className="LoginTest"/>
		  <span>
			{/* <label className="loginInput-label" htmlFor="uname">
			  Username*
			</label> */}
			<Input
		      prefix={<UserOutlined className="site-form-item-icon" />}
			  onChange={handleChange}
			  id="email"
			  name="email"
			  value={verifyInfo.email}
			  placeholder="Enter your username"
			  className="loginInput"
			  type="email"
			  //   required
			/>
		  </span>{" "}
		  <span>
			{/* <label className="loginInput-label" htmlFor="uname">
			  Code *
			</label> */}
			<Input
			  prefix={<QrcodeOutlined  className="site-form-item-icon" />}
			  disabled={disabled}
			  onChange={handleChange}
			  value={verifyInfo.code}
			  id="code"
			  name="code"
			  placeholder="Enter your verification code"
			  className="loginInput"
			  required
			  autoFocus
			/>
		  </span>
		  <span>
			<button
			  disabled={disabled}
			  className="btns btnLogin"
			>
			  Verify
			</button>
		  </span>
		  <div className="regFoot">
			<span>Don't have yet an account?</span>{" "}
			<span onClick={() => (window.location.pathname = "/register")}>
			  Register here
			</span>
		  </div>
		  <div className="regFoot">
		
		  </div>
		</form>
	  </div>
	</div>
  </>
  )
}

export default Verify